import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const wrapper: SxStyle = {
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
};

export const root: SxStyleFunc = (isMostPopular) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flex: 1,
  minWidth: 0,
  maxWidth: '100%',
  background: isMostPopular
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.common.white,
  padding: (p) => p.spacing(1.5),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.primary[500],
  borderRadius: (p) => p.spacing(0.5),
  boxSizing: 'border-box',
});

export const compactRoot: SxStyleFunc<boolean | undefined> = (
  isMostPopular
) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flex: 1,
  minWidth: 0,
  maxWidth: '100%',
  background: isMostPopular
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.common.white,
  padding: (p) => p.spacing(1.5),
  border: 'none',
  borderRadius: 0,
  boxSizing: 'border-box',
});

export const actionSlot: SxStyle = {
  marginTop: 'auto',
};
